import React, { useState } from "react";
import { fadeUp, fadeRightToLeft } from "../";
import FormatQuoteRoundedIcon from "@mui/icons-material/FormatQuoteRounded";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { motion } from "framer-motion";
import { useRef } from "react";
import { useEffect } from "react";
import {
  Ahelee,
  Alexander,
  Amy,
  An,
  Andy,
  Ashani,
  Carol,
  Cindy,
  Danielle,
  Diya,
  Emily,
  Jade,
  Jesslyn,
  Jiya,
  Lilian,
  Magdalene,
  Megan,
  Nhi,
  Pakhi,
  Rachael,
  Ryan,
  Sabina,
  Samantha,
  Sammi,
  Stacey,
  Sylvia,
  Tammy,
  Tristina,
} from "../";
import OurLeadership from "./OurLeaderships";

const OurTutors = () => {
  const numberTag = "bg-white border-blue text-blue";
  const languageTag = "bg-white border-purple text-blue";
  const scienceTag = "bg-white border-orange text-blue";
  const otherTag = "bg-white border-yellow text-blue";
  const [showModal, setShowModal] = useState(false);
  const [{ tutorName, tutorDescription, tutorImage, testimonial }, setTutor] =
    useState({});
  const handleClick = (e) => {
    const targetIndex = e.target.getAttribute("data-index");
    setTutor({
      tutorName: tutorToDisplay[targetIndex].name,
      tutorDescription: tutorToDisplay[targetIndex].description,
      tutorImage: tutorToDisplay[targetIndex].imageUrl,
      testimonial: tutorToDisplay[targetIndex].testimonial,
    });
    setShowModal(true);
  };

  const people = [
    {
      name: "Ahelee",
      role: "Primary Mathematics | Secondary Mathematics | VCE Biology | VCE English | VCE English Language",
      imageUrl: Ahelee,
      description:
        "Ahelee was an academic achievement scholarship student and School Captain at Melbourne Girls Grammar. She graduated with an ATAR of 97.70 and is currently completing a Bachelor's degree in Biomedicine at the University of Melbourne. Ahelee has a proven track record in inspiring her students with her strong passion and enthusiasm for English and English Language. Beyond tutoring and pursuing her studies, she is currently the Multicultural Youth Network Facilitator at the Victorian Multicultural Commission, the Senior Youth Ambassador producer and host for the Student Broadcast Network on radio station 94.1FM 3WBC, as well as an Ambassador for MS Australia. Ahelee is also a member of the Youth Advisory Board for Spill The Beans, an organisation that works to empower young people to voice their ideas, stories and inspiration. She is a passionate advocate of the perspectives of young Australians in a democracy as a regular contributor and commentator on The Age, ABC News and her own blog.",
      subjects: [
        ["Primary Mathematics", numberTag],
        ["Secondary Mathematics", numberTag],
        ["VCE Biology", scienceTag],
        ["VCE English", languageTag],
        ["VCE English language", languageTag],
      ],
    },
    {
      name: "Alexander",
      role: "Secondary Mathematics | VCE Biology | VCE Mathematics - Methods",
      imageUrl: Alexander,
      description:
        "Alexander is a highly accomplished academic achiever, having attained an impressive ATAR of 98.30. His dedication to learning has led him to pursue a Bachelor of Radiography and Medical Imaging (Honours) at Monash University. As a tutor, Alexander brings the same level of enthusiasm and commitment, consistently striving to ensure his students grasp concepts thoroughly. He understands that each student learns differently and, therefore, meticulously tailors his lessons to address their specific learning styles and academic requirements. Beyond his passion for education, Alexander enjoys expressing his creativity through photography and finds relaxation and fulfillment in playing the guitar. His diverse interests and well-rounded personality allow him to connect with students on multiple levels, fostering a supportive and engaging learning environment.",
      subjects: [
        ["Secondary Mathematics", numberTag],
        ["VCE Biology", scienceTag],
        ["VCE Mathematics - Methods", numberTag],
      ],
    },
    {
      name: "Amy",
      role: "Primary English | Primary Mathematics | Secondary English | Secondary Mathematics | VCE English | VCE Mathematics - Methods",
      imageUrl: Amy,
      description:
        "Amy, a graduate of Korowa Anglican Girls School, is currently pursuing a Bachelor of Medical Science and Doctor of Medicine at Monash University. Amy distinguished herself in English, attaining a raw Study Score of 48, placing her in the top 0.6 percent in Victoria. In English, she maintained a moderated SAC average of 100 percent, scored 20 out of 20 in Section B of the examination and achieved a perfect Study Score of 50 in the writing section of the GAT. Additionally, she earned a Study Score of 40 in Mathematical Methods, and has extensive experience with scholarship testing. As a medical student, Amy is interested in specialising in Paediatrics! She thoroughly enjoys working with students of all ages, aiding them in reaching their full potential. As a seasoned tutor, Amy recognises the importance of tailoring lessons to meet individual needs, passionately striving to create the best possible learning environment for each student. She offers a variety of resources, including vocabulary banks, exemplar essays, notes, critical readings and practise questions. Beyond her studies, Amy likes cooking new recipes and pilates!",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary English", languageTag],
        ["Secondary Mathematics", numberTag],
        ["VCE English", languageTag],
        ["VCE Mathematics - Methods", numberTag],
      ],
    },
    {
      name: "An",
      role: "Primary Mathematics | Secondary Mathematics | VCE Mathematics - Methods",
      imageUrl: An,
      description:
        "An graduated with an ATAR of 95.30 from Mac.Robertson Girls' High School and is currently pursuing a Psychology degree at the University of Melbourne. She has experience tutoring Mathematics and Science and has worked with a wide range of primary and secondary students. An understands that each student has unique capabilities and needs and can help them build on their strengths and overcome their challenges. She can break down complex concepts so that they are easy to understand and provide in-depth explanations for those who want to extend their knowledge. An is committed to bringing out the best in each student and supporting them as they develop their academic skills.",
      subjects: [
        ["Primary Mathematics", numberTag],
        ["Secondary Mathematics", numberTag],
        ["VCE Mathematics - Methods", numberTag],
      ],
    },
    {
      name: "Andy",
      role: "Secondary Mathematics | VCE Mathematics - General",
      imageUrl: Andy,
      description:
        "An experienced educator, Andy has extensive teaching experience spanning government, leading independent, and Catholic schools, utilizing High Impact Teaching Strategies and current pedagogical approaches. He began his teaching career in 2017 with Junior Mathematics, followed by VCE General Mathematics and Physics. He previously served as the Director of Professional Learning, where he collaborated with Domain Leaders, the Assistant Principal, and teaching staff to align learning and teaching practices with the school's Strategic Plan. Andy graduated from VCE in 2012 with an ATAR of 93.10 and subsequently received the Deakin International Scholarship to pursue a double degree in Teaching and Science. He completed his Bachelor of Teaching and Bachelor of Science in 2016, achieving Distinction in both.",
      subjects: [
        ["Secondary Mathematics", numberTag],
        ["VCE Mathematics - General", numberTag],
      ],
    },
    {
      name: "Ashani",
      role: "Primary English | Primary Mathematics | Secondary Mathematics | VCE Mathematics - General | VCE Mathematics - Methods",
      imageUrl: Ashani,
      description:
        "Ashani is a dedicated English and Mathematics tutor who graduated from Mac.Robertson Girls' High School with an ATAR of 97+. She brings a strong academic background and a passion for teaching to every lesson, helping students build confidence and competence across core subjects. Ashani focuses on developing deep conceptual understanding in both English and Mathematics, while also nurturing essential skills such as critical thinking, problem-solving, and clear communication. Her teaching style balances rigour with empathy, ensuring that students not only meet but exceed their academic goals at school. With personalised guidance and targeted practice, Ashani supports learners at all levels, whether they're aiming to improve foundational skills, stay ahead of classwork, or prepare for assessments. Her calm and encouraging approach creates a supportive learning environment where students feel empowered to grow. Ashani is currently studying a Bachelor of Laws (Honours) and Bachelor of Commerce at Monash University. Outside of tutoring, she enjoys cooking and reading.",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary Mathematics", numberTag],
        ["VCE Mathematics - General", numberTag],
        ["VCE Mathematics - Methods", numberTag],
      ],
    },
    {
      name: "Carol",
      role: "Primary Mathematics | Secondary Mathematics | VCE Mathematics - Methods",
      imageUrl: Carol,
      description:
        "Carol is a dedicated and experienced Mathematics tutor who graduated from Mac.Robertson Girls’ High School with an ATAR of 97.95. Currently pursuing a Bachelor of Science degree at the University of Melbourne, majoring in Data Science, Carol continues to demonstrate her passion for Mathematics. Drawing upon her previous teaching experience, she effectively tailors her teaching approach to meet the unique learning needs of each student. Carol focuses on fostering critical thinking and problem-solving abilities to facilitate their academic growth.",
      subjects: [
        ["Primary Mathematics", numberTag],
        ["Secondary Mathematics", numberTag],
        ["VCE Mathematics - Methods", numberTag],
      ],
    },
    {
      name: "Cindy",
      role: "Primary English, Primary Mathematics, Secondary English, Secondary Mathematics, QCE Biology, QCE Physics, QCE Mathematics - Methods, QCE Mathematics - Specialist",
      imageUrl: Cindy,
      description:
        "Cindy achieved an ATAR of 98.4, leading her to pursue Medical Imaging at Queensland University of Technology. Academically, she excelled in Physics (98/100) and Chemistry (97/100), achieving the raw scores in her school for these subjects. Additionally, she obtained strong external raw scores in Mathematical Methods (47/50) and Mathematical Specialist (45/50). Her success extended to Biology (93/100), English General (100/100), and Chinese (93/100). Cindy has experience tailoring her teaching and tutoring approach to meet diverse student needs, including assignment, examination, and concept-based support. Being a recent graduate, she possesses a strong understanding of the current QCE system and can provide ample assessment resources. Beyond academics, Cindy is enthusiastic about stress management and discovering simpler learning techniques.",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary English", languageTag],
        ["Secondary Mathematics", numberTag],
        ["QCE Biology", scienceTag],
        ["QCE Physics", numberTag],
        ["QCE Mathematics - Methods", numberTag],
        ["QCE Mathematics - Specialist", numberTag],
      ],
    },
    {
      name: "Danielle",
      role: "Secondary Mathematics | VCE Mathematics - General | VCE Mathematics - Methods",
      imageUrl: Danielle,
      description:
        "Danielle is a dedicated medical student at Monash University with a passion for teaching and over five years of tutoring experience. Achieving an impressive ATAR of 98.6, she knows what it takes to excel and is committed to helping students reach their full potential. Danielle’s approach focuses on building foundational skills and simplifying complex concepts, ensuring students have a solid understanding of topics that will empower them when completing questions. Known for her patient and supportive manner, she provides useful shortcuts and strategies that make Mathematics more approachable. Danielle’s students quickly see marked improvements, gaining both academic skills and valuable confidence. Her goal is to help students grow, achieve their personal best, and thrive academically.",
      subjects: [
        ["Secondary Mathematics", numberTag],
        ["VCE Mathematics - General", numberTag],
        ["VCE Mathematics - Method", numberTag],
      ],
    },
    {
      name: "Diya",
      role: "Secondary English | Secondary Mathematics | VCE Biology | VCE Mathematics - Methods | VCE Psychology",
      imageUrl: Diya,
      description:
        "Graduating from MacRobertson Girls' High School, Diya is currently completing the Bachelor of Biomedical Science at Monash University. She has successfully sat and aced the selective school entrance examination, and further has extensive knowledge in VCE Biology and Psychology as well as tips and tricks for examination success. She caters her teachings to the student through strengths and weaknesses and has a strong focus on strategy when it comes to answering questions. Having completed multiple Mathematics and Science competitions back in her secondary school days to a high degree, and further exploring her passion in public speaking, Diya has an in-depth understanding of Mathematics, English and Science in the secondary years, which she can explain in various methods to students, to enhance learning.",
      subjects: [
        ["Secondary English", languageTag],
        ["Secondary Mathematics", numberTag],
        ["VCE Biology", scienceTag],
        ["VCE Mathematics - Methods", numberTag],
        ["VCE Psychology", scienceTag],
      ],
    },
    {
      name: "Emily",
      role: "Primary Mathematics | VCE Biology | VCE Chemistry",
      imageUrl: Emily,
      description:
        "Emily graduated from the VCE with an ATAR of 96.45 with her top subjects being Biology and Chemistry.  Her genuine interest in both of these subjects in particular allowed her to achieve raw Study Scores in the top 9 percent in Victoria. Emily was awarded the Anne Symons Biology prize upon graduation and was a part of the Monash Scholars Program throughout her senior years of school. She always loved helping other students understand concepts and acknowledges that everyone has different learning styles and techniques that work for them. Emily has had experience peer mentoring others across a wide age span as she has held leadership roles in various extracurricular activities and programs, and truly wants to help students find a way to enjoy their learning rather than simply striving to understand content. She has a wide range of notes, practice questions and SACs to share, and is open to helping students shape their sessions to suit whatever they need, including refining knowledge on specific topics or practising SAC and examination questions and techniques. Emily is currently completing a Bachelor of Nursing and Paramedicine degree. Beyond studying and tutoring, Emily loves music, dancing and outdoor activities like travelling and camping!",
      subjects: [
        ["Primary Mathematics", numberTag],
        ["VCE Biology", scienceTag],
        ["VCE Chemistry", scienceTag],
      ],
    },
    {
      name: "Jade",
      role: "Primary Mathematics | Secondary Mathematics | VCE Mathematics | VCE Physics | VCE Mathematics - Methods",
      imageUrl: Jade,
      description: `Jade graduated with an ATAR of 99.35. Her academic prowess shone in Physics, where she earned the prestigious PJ Sharman Memorial Award for Academic Excellence in VCE Physics. Jade also excelled in VCE Mathematical Methods, scoring a raw Study Score of 47. She is currently pursuing a Bachelor of Engineering (Honours) and a Bachelor of Commerce under the esteemed Women in Engineering Scholarship. Jade's strengths lie in understanding and applying technical concepts proficiently. As a tutor, she tailors her teaching style to each student's needs, guiding them through content, providing worked solutions, and answering homework questions effectively. Outside of Jade's studies, she enjoys staying active by playing netball. Her dedication, academic achievements, and passion for teaching make her a valuable asset to our team.`,
      subjects: [
        ["Primary Mathematics", numberTag],
        ["Secondary Mathematics", numberTag],
        ["VCE Mathematics", numberTag],
        ["VCE Physics", numberTag],
        ["VCE Mathematics - Methods", numberTag],
      ],
    },
    {
      name: "Jesslyn",
      role: "Primary English | Primary Mathematics | Secondary Mathematics",
      imageUrl: Jesslyn,
      description:
        "Jesslyn is a dedicated and compassionate educator who brings a wealth of experience to her tutoring practice, having successfully supported primary and high school students, including those with diverse learning needs. Her commitment to education is further underscored by her current pursuit of a Bachelor of Arts and Bachelor of Education at the esteemed Monash University. Jesslyn has cultivated a reputation for her gentle, nurturing approach, which creates a comfortable and encouraging learning atmosphere, while her confident tutoring style ensures students receive clear and effective guidance. Leveraging her strong organisational abilities and well-developed pedagogical skills, Jesslyn meticulously designs engaging and enriching learning environments tailored to the individual needs of each student. Her academic journey in Melbourne, coupled with valuable international exposure, has broadened her perspectives and instilled in her an open and adaptable outlook, allowing her to connect with students from various backgrounds. Jesslyn possesses a genuine passion for fostering a love of learning in primary school students and firmly believes in the crucial importance of building a robust educational foundation that will empower them throughout their academic journeys. Her dedication extends beyond simply imparting knowledge; she strives to instill confidence, critical thinking skills, and a lifelong enthusiasm for learning in every student she works with.",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary Mathematics", numberTag],
      ],
    },
    {
      name: "Jiya",
      role: "Primary English | Secondary English | VCE Business Management | VCE English | VCE Health and Human Development | VCE Sociology",
      imageUrl: Jiya,
      description:
        "Jiya graduated from Haileybury Girls College with an ATAR of 97.30 and is now pursuing a Bachelor of Physiotherapy at Monash University. During her VCE studies, she achieved outstanding results, placing in the top 2 percent in Victoria for English and Sociology, and in the top 8 percent for Business Management and Health and Human Development based on her raw Study Scores. Jiya's tutoring approach is highly personalised; she customizes her lessons and develops learning materials to suit each student's individual needs and learning style. This includes creating notes, practice questions and key study tips. Her passion for tutoring began when she tutored a family friend a few years ago, and witnessing his increased confidence throughout the year motivated her to help other students succeed. Beyond her studies, she's learning to play instruments such as the guitar. She is looking forward to working with any upcoming students!",
      subjects: [
        ["Primary English", languageTag],
        ["Secondary English", languageTag],
        ["VCE Business Management", numberTag],
        ["VCE English", languageTag],
        ["VCE Health and Human Development", otherTag],
        ["VCE Sociology", otherTag],
      ],
    },
    {
      name: "Lilian",
      role: "Secondary Mathematics | VCE Mathematics - General | VCE Mathematics - Methods",
      imageUrl: Lilian,
      description:
        "Lilian graduated as Dux of Wheelers Hill High School with an impressive ATAR of 99.35, demonstrating her strong commitment to academic excellence. Notably, she achieved exceptional raw Study Scores of 45 and 50 in VCE Mathematical Methods and General Mathematics respectively through self-study and consistent practice, without external tutoring. Currently, Lilian is pursuing a Bachelor of Secondary Education and Science at Monash University, where she is further developing her teaching craft. Her outstanding achievements have been recognized with the prestigious Sir John Monash Scholarship for Excellence. As a tutor, Lilian aims to demystify complex ideas, share effective learning strategies, and provide the necessary encouragement for students to thrive. She is deeply passionate about empowering students to reach their full potential. Lilian is enthusiastic about guiding students towards both academic and personal success.",
      subjects: [
        ["Secondary Mathematics", numberTag],
        ["VCE Mathematics - General", numberTag],
        ["VCE Mathematics - Methods", numberTag],
      ],
    },
    {
      name: "Magdalene",
      role: "Primary English | Primary Mathematics | Secondary English | Secondary Mathematics | VCE English | VCE Legal Studies",
      imageUrl: Magdalene,
      description:
        "Magdalene, an accomplished graduate with an impressive ATAR of 94.25, is currently undertaking a double degree in Bachelor of Arts and Bachelor of Laws at Monash University. Her own success in the VCE places her in a unique position to understand the demands of secondary education and equip her students with invaluable strategies for academic triumph. Magdalene goes beyond simply delivering content, focusing on imparting crucial tips and tricks that are often the key differentiators for high-achieving students. Her tutoring sessions are enriched with comprehensive and insightful resources meticulously designed to foster a deep understanding of the subject matter and empower students to reach their full potential in their respective academic years. Recognising the particular pressures associated with Year 12, Magdalene offers empathetic guidance to help students effectively manage stress and maintain well-being while diligently working towards their goals. As a tutor, her primary aspiration is to empower each student not only to meet their academic targets but to surpass them through personalized sessions carefully tailored to their individual learning styles and habits. She is committed to creating a supportive and encouraging learning environment where students feel motivated and confident to excel. Beyond Magdalene's academic prowess, she is a passionate foodie and enjoys playing tennis, bringing a well-rounded perspective to her interactions with students.",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary English", languageTag],
        ["Secondary Mathematics", numberTag],
        ["VCE English", languageTag],
        ["VCE Legal Studies", otherTag],
      ],
    },
    {
      name: "Megan",
      role: "Primary English, Primary Mathematics, Secondary English, Secondary Mathematics, QCE Biology, QCE Economics, QCE English",
      imageUrl: Megan,
      description:
        "Megan is an alumna of the selective-entry Brisbane State High School. She scored an ATAR of 98.45 for her QCE and is currently studying a Bachelor of Physiotherapy. She not only excelled in subjects like Chemistry and English, achieving raw scores of 98 in both, but also has over two years of tutoring experience, helping students navigate their academic journey. Megan can efficiently adapt her teaching style to suit the unique needs of each student, recognizing that everyone learns differently. Whether a student needs a comprehensive overview of a subject, assistance with homework, or detailed explanations through interactive question-and-answer sessions, she is well-equipped to provide support. Megan looks forward to guiding each student towards exam success and overall academic growth.",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary English", languageTag],
        ["Secondary Mathematics", numberTag],
        ["QCE Biology", scienceTag],
        ["QCE Economics", numberTag],
        ["QCE English", languageTag],
      ],
    },
    {
      name: "Nhi",
      role: "Primary English | Primary Mathematics | Secondary English | Secondary Mathematics | VCE Chemistry | VCE English | VCE Mathematics - General",
      imageUrl: Nhi,
      description:
        "Nhi graduated with a Bachelor of Commerce from the University of Melbourne after completing her VCE with an ATAR of 94.90 and receiving a Melbourne Access Scholarship. Passionate about Chemistry, she achieved a raw Study Score in the top 8 percent in Victoria and received an award for academic achievement in Units 3 and 4 VCE Chemistry. Nhi also tutors General Mathematics and English, both subjects in which she attained raw Study Scores in the top 9 percent in Victoria. With over three years of experience providing both group and private tutoring to more than 200 students, Nhi is adept at customising lessons to suit individual learning styles and needs. Recognising the challenges of VCE Chemistry, General Mathematics, and English, she provides comprehensive support through resources such as past exam questions, her personal notes, and guidance on efficient data booklet usage. Her extensive tutoring background has given her a thorough understanding of the VCE Study Design. Outside of her academic pursuits, Nhi enjoys reading and painting. She is enthusiastic about continuing to support VCE students through what can be a demanding period in their high school journey by sharing her knowledge and skills.",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary English", languageTag],
        ["Secondary Mathematics", numberTag],
        ["VCE Chemistry", scienceTag],
        ["VCE English", languageTag],
        ["VCE Mathematics - General", numberTag],
      ],
    },
    {
      name: "Pakhi",
      role: "Primary English |Primary Mathematics | Secondary English | VCE English | VCE English Literature | VCE Psychology",
      imageUrl: Pakhi,
      description:
        "Pakhi graduated from the Mac. Robertson Girls' High School with an ATAR of 97+. She achieved Study Scores in the top 2 percent in Victoria in VCE Literature and Philosophy and within the top 9 percent in Psychology, Global Politics, Methods and French. Pakhi's achievement in Philosophy was recognised as the recipient of The Philosophy Award. She efficiently tailors her teaching style to match the needs of every student, ensuring tangible growth across all subject areas. Pakhi is adept at formulating and providing comprehensive resources that will unlock a student's full potential and provide them with a vital skill set to succeed in VCE Exams, scholarship and entrance tests, and beyond. Her approach breaks down content in an accessible manner, allowing students to gain content literacy, and ensuring fluency in their expression. Pakhi's aim lies in preparing students for all types of questions and using the set exam structure to their advantage. Beyond tutoring, she is pursuing an Arts and Law (Honours) degree at Monash University.",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary English", languageTag],
        ["VCE English", languageTag],
        ["VCE English Literature", languageTag],
        ["VCE Psychology", scienceTag],
      ],
    },
    {
      name: "Rachael",
      role: "Primary English |Primary Mathematics | Secondary English | Secondary Mathematics",
      imageUrl: Rachael,
      description:
        "Rachael has recently graduated VCE from Haileybury Girls College with an ATAR of 90+, she is currently completing a Bachelor of Science at Monash University. She understands the importance of creating a unique learning style that suits the student through clear communication and tailoring an open, supportive approach to learning. Focusing on patience and personalized support, Rachael goes beyond just teaching the material - she will help guide students through the process, ensuring that the student not only understands the concepts but can also apply it to various different questions. Outside of academics, she enjoys spending time in the kitchen creating a variety of different dishes and sweets.",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary English", languageTag],
        ["Secondary Mathematics", numberTag],
      ],
    },
    {
      name: "Ryan",
      role: "Primary Mathematics | Secondary Mathematics | VCE Mathematics - General",
      imageUrl: Ryan,
      description:
        "Graduating with an ATAR of 98.95 from Haileybury College, Ryan is currently studying a double degree in Engineering and Commerce at Monash University. He was previously a recipient of an academic scholarship from Haileybury and achieved a raw Study Score of 47 in General Mathematics. As a tutor, Ryan actively encourages students to ask questions, and his teaching style is designed to make the learning experience for students more interactive and collaborative. Having aced the VCE himself, Ryan not only will be able to provide tips and tricks for excelling in exam preparation but also offer support and advice for dealing with the stress and challenges of VCE. Outside of his studies, Ryan is passionate about sports such as soccer and basketball.",
      subjects: [
        ["Primary Mathematics", numberTag],
        ["Secondary Mathematics", numberTag],
        ["VCE Mathematics - General", numberTag],
      ],
    },
    {
      name: "Sabina",
      role: "Primary English | Primary Mathematics | Secondary English | Secondary Mathematics | VCE Legal Studies",
      imageUrl: Sabina,
      description:
        "Sabina graduated from Nossal High School with a 98+ ATAR  and is currently studying Law (Honours) and Arts at Monash University. Having achieved Study Scores within the top 9 percent in Victoria in four of her subjects, she has extensive knowledge on how to succeed in VCE, and can also assist primary and secondary students in building strong foundational skills. Sabina recognises that everyone learns differently and employs a flexible teaching style to suit the student's individual needs. In each lesson, time will be dedicated to applying knowledge through scenario-based questions and by breaking down possible solutions. Her patient and friendly demeanour assists in making students feel as comfortable as possible no matter where they are in their learning journey. Outside of studying, Sabina enjoys staying active and playing musical instruments. Having received the Endeavour Award and the All Rounder Award in Year 12, she knows how beneficial it is to engage in hobbies for learning (and enjoyment too!). She looks forward to empowering students to achieve their full academic potential!",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary English", languageTag],
        ["Secondary Mathematics", numberTag],
        ["VCE Legal Studies", otherTag],
      ],
    },
    {
      name: "Samantha",
      role: "Primary English | Primary Mathematics | Secondary English | VCE Biology | VCE English Language",
      imageUrl: Samantha,
      description:
        "Samantha achieved an ATAR of 98 with Study Scores within the top 9 percent of Victoria in Biology and English. Her academic portfolio was further enriched through her participation in the ANCQ Chemistry Competitions, Australian Brain Bee Challenge, DAV Debating, Full Steam Ahead Engineering, and Write a Book in a Day. Samantha understands that to achieve success as a student, students must be well-rounded and be able to balance studies alongside their purpose and passions outside their academic life. She tailors her lessons to suit every student's individual needs, including but not limited to their personality, personal goals, and preferences. Samantha is studying a Bachelor of Law and Arts at Monash University, and is actively maintaining a Distinction average in her tertiary studies. ",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary English", languageTag],
        ["VCE Biology", scienceTag],
        ["VCE English Language", languageTag],
      ],
    },
    {
      name: "Sammi",
      role: "Primary Mathematics | Secondary Mathematics",
      imageUrl: Sammi,
      description:
        "Sammi brings a wealth of educational expertise to her teaching practice, holding qualifications spanning both primary and secondary education. Her academic journey commenced at Monash University, where she earned a Bachelor of Science alongside a Bachelor of Education (Honours) specialising in Primary Education. Sammi furthered her studies at The University of Melbourne, completing a Master of Teaching (Secondary) with a focus on Physics and Mathematics as her teaching methodologies. Currently, she is a practicing teacher at a highly sought-after girls’ school in Melbourne's southeast, where she actively instructs students in Mathematics and Science. This ongoing classroom experience ensures that her teaching methods are current, relevant to the curriculum, and informed by the practical realities of teaching these subjects to secondary students. Her dual qualification and experience across primary and secondary levels make her uniquely positioned to support students at various stages of their academic journey, providing a comprehensive and well-informed approach to tutoring in Mathematics and Science.",
      subjects: [
        ["Primary Mathematics", languageTag],
        ["Secondary Mathematics", numberTag],
      ],
    },
    {
      name: "Stacey",
      role: "Secondary Mathematics | VCE Mathematics - Methods",
      imageUrl: Stacey,
      description:
        "Graduating with an ATAR of 99.3, Stacey is currently studying a Bachelor of Laws/Arts at Monash University. Stacey left high school with a vested passion for Mathematics and achieved a raw Study Score in the top 3 percent in Victoria. Stacey provides goal-oriented and personalised tutoring sessions to ensure all her students experience a tailored session! Whether it be answering specific questions, a general overview of topics or general tips on how to ace VCE, Stacey can provide comprehensive support! Beyond her studies, Stacey enjoys fashion and bouldering in her spare time. She looks forward to guiding each student through their VCE journey!",
      subjects: [
        ["Secondary Mathematics", numberTag],
        ["VCE Mathematics - Methods", numberTag],
      ],
    },
    {
      name: "Sylvia",
      role: "Primary English | Secondary English | Primary Mathematics | Secondary Mathematics",
      imageUrl: Sylvia,
      description:
        "Sylvia is an exceptionally accomplished and multifaceted individual currently pursuing a demanding Degree in Medicine at Bond University. Her commitment to academic excellence is further underscored by her prior successful completion of the rigorous IBDP at Wesley College. Over the past several years, Sylvia has cultivated extensive experience as a tutor, demonstrating her versatility and deep understanding across a broad spectrum of educational levels. She has effectively guided primary, middle school, VCE, IBDP, and tertiary students in a diverse range of subject areas, showcasing her adaptability and comprehensive knowledge base. Beyond individual tutoring, Sylvia has also contributed her pedagogical skills to TAFE institutions, further highlighting her commitment to education across different learning environments. Sylvia possesses a remarkable ability to forge strong connections with her students, creating a supportive and encouraging learning atmosphere. She excels at demystifying complex concepts, breaking them down into easily digestible components to facilitate deeper understanding and retention. Sylvia's exceptional communication skills are a cornerstone of her teaching philosophy, enabling her to convey information clearly, concisely, and in a manner that resonates with each individual student's learning style. Sylvia's proven track record demonstrates her consistent ability to empower students to achieve their academic goals and foster a genuine love for learning.",
      subjects: [
        ["Primary English", languageTag],
        ["Secondary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary Mathematics", numberTag],
      ],
    },
    {
      name: "Tammy",
      role: "Primary English | Primary Mathematics",
      imageUrl: Tammy,
      description:
        "Tammy brings a wealth of experience as a classroom teacher at one of Melbourne's top-performing NAPLAN schools. Her deep understanding of effective pedagogy is underpinned by a strong academic foundation, including a Bachelor of Science with a major in Developmental Biology and a Bachelor of Education (Honours), both earned at Monash University. During her university years, Tammy honed her instructional skills by working as a tutor for a well-respected tutoring centre, demonstrating her early commitment to supporting student learning. Furthermore, her professional development includes valuable international teaching experience gained in the United Kingdom, providing her with a broader perspective on educational practices and diverse learning environments. Tammy's comprehensive background ensures she is well-equipped to cater to a variety of learning needs and to inspire academic success in her students.",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
      ],
    },
    {
      name: "Tristina",
      role: "Primary English | Primary Mathematics | Secondary English | Secondary Mathematics | VCE Biology | VCE English | VCE Mathematics - General | VCE Psychology",
      imageUrl: Tristina,
      description:
        "Tristina is a highly engaging, enthusiastic and passionate tutor who is highly regarded for going above and beyond for her students. She holds a Bachelor of Science from the University of Melbourne and is presently pursuing a Master of Veterinary Medicine at the same university. Tristina attained an ATAR of 95.70 on the Victorian Certificate of Education (VCE), including a distinguished Study Score of 46 in English. As a tutor, she strives to build rapport with her students to understand their needs and navigate ways to employ their skills confidently. Tristina's dedication is evident in her ample and insightful feedback on her students' work. She also formulates notes and gathers resources that best suit her students' academic goals. Outside Tristina's studies, she enjoys spending time with her pets and exploring new skills such as crocheting. ",
      subjects: [
        ["Primary English", languageTag],
        ["Primary Mathematics", numberTag],
        ["Secondary English", languageTag],
        ["Secondary Mathematics", numberTag],
        ["VCE Biology", scienceTag],
        ["VCE English ", languageTag],
        ["VCE Mathematics - General", numberTag],
        ["VCE Psychology", scienceTag],
      ],
    },
  ];

  /**  Subject filters **/
  let uniqueTutorToDisplay = [];
  const [tutorToDisplay, setTutorToDisplay] = useState(people);
  // Search name function
  const [query, setQuery] = useState("");
  const handleInputChange = (e) => {
    setQuery(e.target.value);
    const includeName = people.filter((tutor, index) => {
      return tutor.name.toLowerCase().includes(query.toLowerCase());
    });
    uniqueTutorToDisplay = [];
    includeName.map((tutor) => {
      if (!uniqueTutorToDisplay.includes(tutor)) {
        return uniqueTutorToDisplay.push(tutor);
      }
    });
    setTutorToDisplay(uniqueTutorToDisplay);
  };
  // End - Search name function
  // Filter Scrolling
  const filter = useRef();
  useEffect(() => {
    setWidth(filter.current.scrollWidth - filter.current.offsetWidth);
  }, []);
  const [width, setWidth] = useState(0);
  // End - Filter Scrolling

  // Display Filtered tutors after clicked

  const filterSubjects = async (tag) => {
    uniqueTutorToDisplay = [];
    people.map((tutor, index) => {
      tutor.subjects.filter((subject, filterIndex) => {
        const filteredTutors = subject[0].toLowerCase().includes(tag);
        if (filteredTutors) {
          if (!uniqueTutorToDisplay.includes(tutor)) {
            return uniqueTutorToDisplay.push(tutor);
          }
        }
      });
    });
    setTutorToDisplay(uniqueTutorToDisplay);
  };
  // End - Display Filtered tutors after clicked
  /**  END - Subject filters **/

  return (
    <div className="bg-white">
      <OurLeadership />
      <div className="mx-auto py-12 px-4 max-w-[89rem] sm:px-6 lg:px-8 lg:py-24">
        <div className="space-y-12">
          <motion.div
            variants={fadeUp}
            initial={"hidden"}
            whileInView={fadeUp.visible}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            className="flex flex-col justify-center gap-2">
            {/* <h2 className="text-lg text-center font-semibold tracking-wider text-purple uppercase">
              MEET OUR BEST AND BRIGHTEST TUTORS
            </h2> */}
            <p className="text-center text-blue text-5xl font-bold">
              Our Tutors
            </p>
          </motion.div>
          {/* SEARCH AND FILTER */}
          <div className="flex flex-col justify-center items-center overflow-hidden">
            {/* Search bar + Heading */}
            <motion.div
              variants={fadeUp}
              initial={"hidden"}
              whileInView={fadeUp.visible}
              transition={{ duration: 1, delay: 0.2 }}
              viewport={{ once: true }}
              className="flex flex-col md:flex-row justify-center items-center gap-5 w-full">
              <h1 className="text-purple font-bold">Search for Tutor's name</h1>
              {/* Search bar */}
              <div className="relative text-gray-500 mb-10 mr-56 flex justify-center items-center">
                <MagnifyingGlassIcon className="w-5 h-5 absolute left-2 top-0 mt-[0.6rem] text-purple z-50" />
                <input
                  className="absolute top-0 ml-64 border-2 border-gray-300 bg-white h-10 px-10 pr-16 rounded-lg text-sm focus:outline-none"
                  type="search"
                  name="search"
                  placeholder="Search"
                  value={query}
                  onChange={handleInputChange}
                />
              </div>
              {/* End - Search bar */}
            </motion.div>
            {/* Search bar + Heading */}
            {/* Filter */}
            {/* <div className="flex flex-wrap justify-center items-center gap-5 mt-5"> */}
            {/* <h1 className="text-purple font-bold">Filter by subject</h1> */}
            {/* Subjects */}
            <motion.div
              variants={fadeRightToLeft}
              initial={"hidden"}
              whileInView={fadeRightToLeft.visible}
              transition={{ duration: 1, delay: 0.4 }}
              viewport={{ once: true }}
              ref={filter}
              drag="x"
              dragConstraints={{ right: 0, left: -width }}
              className="flex md:justify-center items-center gap-5 w-full mt-10 p-2">
              <button
                className="w-auto h-5 bg-purple rounded-full ring-2 ring-purple ring-offset-2 text-white p-5 flex items-center"
                onClick={() => setTutorToDisplay(people)}>
                ALL
              </button>

              <button
                className="w-auto h-5 bg-purple rounded-full ring-2 ring-purple ring-offset-2 text-white p-5 flex items-center"
                onClick={() => filterSubjects("english")}>
                English
              </button>
              <button
                className="w-auto h-5 bg-orange rounded-full ring-2 ring-orange ring-offset-2 text-white p-5 flex items-center"
                onClick={() => filterSubjects("biology")}>
                Biology
              </button>
              <button
                className="w-auto h-5 bg-orange rounded-full ring-2 ring-orange ring-offset-2 text-white p-5 flex items-center"
                onClick={() => filterSubjects("chemistry")}>
                Chemistry
              </button>
              <button
                className="w-auto h-5 bg-orange rounded-full ring-2 ring-orange ring-offset-2 text-white p-5 flex items-center"
                onClick={() => filterSubjects("psychology")}>
                Psychology
              </button>
              <button
                className="w-auto h-5 bg-blue rounded-full ring-2 ring-blue ring-offset-2 text-white p-5 flex items-center"
                onClick={() => filterSubjects("physics")}>
                Physics
              </button>
              <button
                className="w-auto h-5 bg-blue rounded-full ring-2 ring-blue ring-offset-2 text-white p-5 flex items-center"
                onClick={() => filterSubjects("math")}>
                Mathematics
              </button>
              <button
                className="w-auto h-5 bg-yellow rounded-full ring-2 ring-yellow ring-offset-2 text-white p-5 flex items-center"
                onClick={() => filterSubjects("legal")}>
                Legal Studies
              </button>
            </motion.div>
            {/* END - Subjects */}
            {/* </div> */}
            {/* End - Filter */}
          </div>
          {/* END - SEARCH AND FILTER */}
          <ul className="text-center space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8 ">
            {tutorToDisplay.map((person, index) => (
              <li key={person.name + index}>
                <div className="space-y-4 ">
                  {/* Tutor Image */}
                  <div className="aspect-w-3 aspect-h-2 relative  border-4 border-purple rounded-xl">
                    {person.imageUrl ? (
                      <img
                        className="object-cover h-[30rem] w-full shadow-lg rounded-lg "
                        src={person.imageUrl}
                        alt={person.name}
                      />
                    ) : (
                      <svg
                        className="object-cover h-[30rem] w-full rounded-full text-gray-300"
                        fill="currentColor"
                        viewBox="0 0 24 24">
                        <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    )}
                  </div>
                  {/* Tutor details */}
                  <div className="space-y-2">
                    <div className="text-lg leading-6 font-medium space-y-1 text-blue">
                      <h3>{person.name}</h3>
                      <div>
                        {person.subjects.map((subject, index) => (
                          <span
                            key={`${subject} ${index}`}
                            className={`${subject[1]}
                           border-2 border-solid mx-1 my-1 inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium`}>
                            {subject[0]}
                          </span>
                        ))}
                      </div>
                    </div>
                    <button
                      data-index={index}
                      className="block w-30 py-1 px-4 mx-auto rounded-xl shadow bg-purple text-white font-medium hover:bg-yellow"
                      onClick={handleClick}>
                      View Profile
                    </button>
                  </div>
                </div>
              </li>
            ))}
            {/* MODAL */}
            {showModal && (
              <>
                <div className="fixed top-0 sm:top-32 lg:top-24 xl:top-30 2xl:top-[8%] 3xl:top-52 left-[5%] lg:left-[15%] xl:left-[25%] 2xl:left-[30%] bg-white border-2 border-purple scrollbar-thumb-grey scrollbar-thin scrollbar-cursor-pointer shadow-xl rounded-xl h-[38rem] sm:h-[32rem] lg:max-h-[120rem] 3xl:h-auto w-[90vw] mx-auto lg:w-[50vw] 2xl:w-[40vw] z-[200] overflow-y-scroll">
                  <XMarkIcon
                    className="hover:bg-yellow hover:ring-yellow w-10 h-10 float-right -translate-x-8 translate-y-8 p-2 rounded-lg text-white bg-purple ring-2 ring-offset-2 ring-purple shadow-lg cursor-pointer"
                    onClick={() => setShowModal(false)}
                  />
                  <div className="text-center mt-5 pb-5 lg:mt-8 border-b border-solid border-slate-200 rounded-t">
                    {tutorImage ? (
                      <img
                        className="m-auto w-40 h-40 mb-5 object-cover rounded-full"
                        src={tutorImage}
                        alt={tutorName}></img>
                    ) : (
                      <svg
                        className="m-auto w-40 h-40 mb-5 object-cover rounded-full text-gray-300"
                        fill="currentColor"
                        viewBox="0 0 24 24">
                        <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    )}
                    <h3 className=" text-2xl font-semibold text-purple">
                      {tutorName}
                    </h3>
                  </div>
                  <div className="relative p-6 flex-auto">
                    <p className="my-4 text-blue text-md lg:text-lg leading-relaxed mb-8">
                      {tutorDescription}
                    </p>

                    {testimonial ? (
                      <div className="text-yellow">
                        <FormatQuoteRoundedIcon
                          className="rotate-180 my-2"
                          sx={{
                            fontSize: "5rem",
                            position: "relative",
                            marginRight: "80%",
                          }}
                        />
                        {testimonial.map((item, index) => (
                          <div
                            key={`testimonial_${index}`}
                            className="flex flex-col justify-center items-center">
                            <p
                              key={"pt-" + index}
                              className="text-base italic font-bold text-blue">
                              {item.feedback}
                            </p>
                            <div className="border-t-2 border-gray-100 my-5">
                              <p
                                key={"pn-" + index}
                                className="mt-1 text-base font-bold text-purple">
                                {item.name}
                              </p>
                              <p
                                key={"pn-" + index}
                                className=" text-base font-normal text-purple">
                                {item.role}
                              </p>
                            </div>
                          </div>
                        ))}
                        <FormatQuoteRoundedIcon
                          sx={{
                            position: "relative",
                            bottom: 50,
                            fontSize: "5rem",
                            marginLeft: "80%",
                          }}
                        />
                      </div>
                    ) : null}

                    <button
                      className="rounded-xl bg-purple text-white hover:bg-yellow font-bold uppercase text-sm px-6 py-3 shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-5 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowModal(false)}>
                      Close
                    </button>
                  </div>
                </div>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OurTutors;
